// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const NissanTheme = props => {
    useThemeStylesheet(() => import("./nissan.lazy.scss"));
    return <>
        <ContrastColorUpdater/>
        {props.children}
    </>;
};

export default NissanTheme;
